module.exports = __webpack_public_path__ + "assets/img/17_1046_big.bdac2723.jpg";